module.exports = __webpack_public_path__ + "static/adjustable-base-2-feature-7610ea2aa35784c8dde6e1303597f106.png";